/**
 * Import
 * - Libraries
 */
import { connect } from 'react-redux'

/**
 * Import
 * - Store
 */
import { RootState } from '../../../store'

/**
 * Import
 * - Selectors
 */
import { getAppLoading } from '../../../selectors/app'
import { getUserSessionState, getUserErrorState } from '../../../selectors/user'

/**
 * Import
 * - Actions
 */
import { forgotTrigger } from '../../../actions'

/**
 * Import
 * - Page component
 */
import { Forgot } from '../../../components/pages/Forgot/Forgot'

/**
 * Map variables from global state to component props
 * @return {object} [description]
 */
const mapStateToProps = (state: RootState) => {
  return {
    loading: getAppLoading(state),
    userSession: getUserSessionState(state),
    userError: getUserErrorState(state),
    forgotStatus: state.user.forgotStatus,
  }
}

/**
 * Connect (props, dispach functions)(component)
 */
export default connect(mapStateToProps, { forgot: forgotTrigger })(Forgot)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/containers/pages/Login/Forgot.tsx